<template>
  <div class="login-page">
    <div class="login-bg"></div>
    <div class="login-wrapper">
      <div class="login-card">
        <div class="login-header">
          <img v-if="systemLogo" :src="getImageUrl(systemLogo)" class="login-logo-img" @error="systemLogo = ''" />
          <i v-else class="el-icon-s-goods login-logo"></i>
          <h1 class="login-title">{{ systemName }}</h1>
          <p class="login-subtitle">存货管理系统</p>
        </div>
        <el-form :model="loginForm" :rules="loginRules" ref="loginForm" class="login-form">
          <el-form-item prop="username">
            <el-input
              v-model="loginForm.username"
              placeholder="请输入用户名"
              prefix-icon="el-icon-user"
              size="large"
              clearable>
            </el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              v-model="loginForm.password"
              type="password"
              placeholder="请输入密码"
              prefix-icon="el-icon-lock"
              size="large"
              show-password
              @keyup.enter.native="handleLogin">
            </el-input>
          </el-form-item>
          <div class="login-row">
            <el-checkbox v-model="rememberMe">记住账号</el-checkbox>
          </div>
          <el-form-item>
            <el-button type="primary" @click="handleLogin" :loading="loading" class="login-btn">登 录</el-button>
          </el-form-item>
        </el-form>
      </div>
      <p class="login-copy">© {{ year }} {{ systemName }}</p>
    </div>
  </div>
</template>

<script>
import { authApi, configApi } from '../api/api'

export default {
  data() {
    return {
      loginForm: { username: '', password: '' },
      loginRules: {
        username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      },
      loading: false,
      rememberMe: false,
      systemName: '存货宝后台管理系统',
      systemLogo: '',
      year: new Date().getFullYear()
    }
  },
  mounted() {
    document.title = '存货宝后台管理系统'
    // 已登录态自动进首页
    if (sessionStorage.getItem('token') && sessionStorage.getItem('user')) {
      this.$router.replace('/dashboard')
      return
    }
    // 恢复"记住的账号"
    const saved = localStorage.getItem('rememberedUsername')
    if (saved) {
      this.loginForm.username = saved
      this.rememberMe = true
    }
    // 拉系统名 + logo（与 App.vue 一致）
    configApi.getConfigs().then(res => {
      if (res.data) {
        if (res.data.system_name && !res.data.system_name.includes('?')) this.systemName = res.data.system_name
        if (res.data.system_logo) this.systemLogo = res.data.system_logo
        document.title = '存货宝后台管理系统'
      }
    }).catch(() => {})
  },
  methods: {
    handleLogin() {
      this.$refs.loginForm.validate((valid) => {
        if (!valid) return
        this.loading = true
        authApi.login(this.loginForm.username.trim(), this.loginForm.password).then(res => {
          if (res.data && res.data.success) {
            sessionStorage.setItem('token', res.data.token)
            sessionStorage.setItem('user', JSON.stringify(res.data.user))
            // 功能权限码（账号管理勾选），按钮/接口据此控制；超管不受限
            sessionStorage.setItem('funcCodes', JSON.stringify(res.data.funcCodes || []))
            if (this.rememberMe) {
              localStorage.setItem('rememberedUsername', this.loginForm.username.trim())
            } else {
              localStorage.removeItem('rememberedUsername')
            }
            this.$message.success('登录成功')
            this.$router.push('/dashboard')
          } else {
            this.$message.error((res.data && res.data.message) || '登录失败')
          }
        }).catch(err => {
          const msg = err && err.response && err.response.data && err.response.data.message
          this.$message.error(msg || '登录请求失败')
        }).finally(() => { this.loading = false })
      })
    },
    getImageUrl(url) {
      if (!url) return ''
      if (url.startsWith('http') || url.startsWith('data:')) return url
      return 'https://chb.bjzkbh.com' + url
    }
  }
}
</script>

<style scoped>
.login-page {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}
.login-bg {
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, #0D47A1 0%, #2793FF 50%, #42A5F5 100%);
}
.login-bg::before {
  content: '';
  position: absolute;
  inset: 0;
  background: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.06'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
}
.login-wrapper {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.login-card {
  width: 460px;
  background: #fff;
  border-radius: 14px;
  padding: 48px 44px 32px;
  box-shadow: 0 20px 60px rgba(13,71,161,0.35);
  border-top: 4px solid #2793FF;
}
.login-header {
  text-align: center;
  margin-bottom: 36px;
}
.login-logo {
  font-size: 54px;
  color: #2793FF;
  display: block;
  margin-bottom: 14px;
}
.login-logo-img {
  width: 64px;
  height: 64px;
  object-fit: contain;
  border-radius: 12px;
  margin-bottom: 14px;
}
.login-title {
  font-size: 30px;
  font-weight: 700;
  color: #0D47A1;
  margin: 0 0 8px;
  letter-spacing: 5px;
}
.login-subtitle {
  font-size: 15px;
  color: #506580;
  margin: 0;
  letter-spacing: 2px;
}
.login-form >>> .el-input__inner {
  height: 50px !important;
  line-height: 50px !important;
  border-radius: 8px;
  font-size: 16px !important;
  border-color: #D6E1EE !important;
}
.login-form >>> .el-input__inner:focus {
  border-color: #2793FF !important;
}
.login-form >>> .el-input__prefix {
  font-size: 18px;
  color: #2793FF;
}
.login-row {
  margin: -6px 0 20px;
  font-size: 15px;
}
.login-btn {
  width: 100%;
  height: 50px;
  border-radius: 8px;
  font-size: 18px !important;
  letter-spacing: 10px;
  background: linear-gradient(135deg, #0D47A1 0%, #2793FF 50%, #0F7CE0 100%) !important;
  border: none !important;
  font-weight: 600;
}
.login-btn:hover {
  opacity: 0.9;
}
.login-tip {
  margin-top: 12px;
  text-align: center;
  font-size: 14px;
  color: #506580;
  padding-top: 12px;
  border-top: 1px dashed #E3F2FD;
}
.login-tip .el-tag {
  margin: 0 5px;
  cursor: pointer;
  font-size: 13px;
}
.login-tip .tip-pwd {
  display: block;
  margin-top: 8px;
  color: #7a8a9a;
}
.login-copy {
  margin-top: 22px;
  color: rgba(255,255,255,0.85);
  font-size: 14px;
  letter-spacing: 1px;
}
</style>
